import $ from "jquery";

window.$ = window.jQuery = $;

( function( $ ) {
	"use strict";

   $(document).ready(function () {

    AOS.init({
        duration: 500,
        once: true,
    });

    // Definisci la funzione updateAOS per aggiornare le animazioni AOS
    window.updateAOS = function() {
    // Trigger AOS.refresh() per aggiornare le animazioni
    AOS.refresh();
    };

});
   
} )( jQuery );



